import { gql } from '@apollo/client';

export const GET_SUGGESTED_QUESTIONS_BY_IDS = gql`
    query GetSuggestedQuestionsByIds($input: GetSuggestedQuestionsByIdsInput!) {
        getSuggestedQuestionsByIds(input: $input) {
            id
            value
            translatedValues {
                value
                language
            }
            taffiId
        }
    }
`;
